import React from "react";
import { useLocation } from "react-router-dom";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_M4_Bellman = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <DAAModuleSubtopic
      title="Bellman Ford Algorithm - Single Source Shortest Path"
      videos={[
        "https://www.youtube.com/embed/FtN3BYH2Zes?list=PLDN4rrl48XKpZkf03iYFl-O29szjTrs_O",
        "https://www.youtube.com/embed/KudAWAMiQog",
      ]}
      takeaways={[
        { text: "Limitation of Dijkstra’s Algorithm." },
        { text: "Principle of Relaxation of Edges." },
        { text: "Detection of a Negative Weight Cycle." },
        { text: "Guarantee of shortest paths without negative cycles." },
        { text: "Time and space complexities." },
      ]}
      questions={[
        "Find the shortest path from source vertex A to all other vertices using a suitable algorithm for the given graph.",
        "Pseudocode of the algorithm.",
        "How Bellman Ford Algorithm is used for detecting negative weight cycles.",
        "Required modifications in the loops in the pseudocode of the Bellman Ford algorithm for early termination of the loop (refer to the previous year paper).",
      ]}
      exampleVideos={[]}
      subtopics={subtopics}
      subjectPath={subjectPath}
    />
  );
};

export default DAA_M4_Bellman;